export function getUrlParam() {
  var url = window.location.href;
  console.log(url)
  // 路径是否包含?
  console.log(url.indexOf('?'));
  if (url.indexOf('?') == -1) {
    return;
  }
  var cs = url.split('?')[1];                //获取?之后的参数字符串
  var param = {};
  if (cs.indexOf('&') != -1) {
    var cs_arr = cs.split('&');   //参数字符串分割为数组
    for (var i = 0; i < cs_arr.length; i++) {         //遍历数组，拿到json对象
      param[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
    }
  } else {
    param[cs.split('=')[0]] = cs.split('=')[1]
  }
  return param;
}



// WEBPACK FOOTER //
// ./src/global/utils.js